import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

interface Volunteer {
  id: number;
  name: string;
  role: string;
  bio: string;
  image: string;
  order_position: number;
  active: boolean;
  origin: string;
  country: string;
  year: number;
}

const Volunteers: React.FC = () => {
  const [volunteers, setVolunteers] = useState<Volunteer[]>([]);
  const [loading, setLoading] = useState(true);

  // Group volunteers by Year -> Program -> Country
  const groupedVolunteers = volunteers.reduce((acc, v) => {
    const year = v.year || new Date().getFullYear();
    const program = v.origin || 'Own';
    const country = (v.country || 'Nepal').trim(); 

    if (!acc[year]) acc[year] = {};
    if (!acc[year][program]) acc[year][program] = {};
    if (!acc[year][program][country]) acc[year][program][country] = [];
    
    acc[year][program][country].push(v);
    
    return acc;
  }, {} as Record<number, Record<string, Record<string, Volunteer[]>>>);

  useEffect(() => {
    // Fetch volunteers from API
    fetch('http://localhost:5000/api/volunteers?active=true')
      .then(res => res.json())
      .then(data => {
        console.log('Volunteers data received:', data);
        data.forEach((volunteer: Volunteer) => {
          console.log(`Volunteer ${volunteer.name} image path:`, volunteer.image);
        });
        setVolunteers(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching volunteers:', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, [volunteers]);

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">Our Volunteers</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i>Our Volunteers</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {loading ? (
        <div className="text-center py-5">
          <p>Loading volunteers...</p>
        </div>
      ) : (
        <>
          {/* Volunteers area start here */}
          <section className="team-area pt-120 pb-120">
            <div className="container">
              {Object.keys(groupedVolunteers).map(y => parseInt(y)).sort((a,b)=>b-a).map(year => (
                <div key={year} className="mb-5">
                  <h2 className="mb-4">{year}</h2>
                  {Object.keys(groupedVolunteers[year]).sort().map(program => {
                    const countries = groupedVolunteers[year][program];
                    const isOwnProgram = program.toLowerCase() === 'own';
                    const hasProgramSuffix = /\bprogram\b/i.test(program);
                    return (
                      <div key={program} className="mb-5">
                        <h3 className="mb-4" style={{ color: '#03A84A' }}>
                          {program}{isOwnProgram || hasProgramSuffix ? '' : ' Program'}
                        </h3>
                        
                        {Object.keys(countries).sort().map(country => (
                          <div key={country} className="mb-4">
                            <h4 className="mb-3">{country}</h4>
                            <div className="row g-4">
                              {countries[country].map((volunteer, index) => (
                                <div key={volunteer.id} className="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay={`${index * 200}ms`} data-wow-duration="1500ms">
                                  <div className="team__item image">
                                    <img
                                      src={volunteer.image || '/assets/images/volunteers/team-image1.jpg'}
                                      alt={volunteer.name}
                                      style={{ width: '100%', height: '451px', objectFit: 'cover' }}
                                      onError={(e) => {
                                        e.currentTarget.src = '/assets/images/volunteers/team-image1.jpg';
                                      }}
                                    />
                                    <div className="team__content">
                                      <div className="content">
                                        <h4><span className="primary-hover">{volunteer.name}</span></h4>
                                        <span>{volunteer.role}</span>
                                        <div className="mt-2" style={{ fontSize: '13px', color: '#6B7280', display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><i className="fa-regular fa-globe" style={{ color: '#03A84A' }}></i> {volunteer.country || 'Nepal'}</span>
                                          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><i className="fa-regular fa-calendar" style={{ color: '#03A84A' }}></i> {volunteer.year || new Date().getFullYear()}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </section>
          {/* Volunteers area end here */}
        </>
      )}
    </>
  );
};

export default Volunteers;
